import { FC } from 'react';
import CopyTextButton from 'v3/common/components/CopyTextButton';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const CoinDcx: FC = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h3>CoinDCX API Setup in 10 Steps</h3>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Go to <span>CoinDCX</span> and log in to your account.
          </h2>
          <button className="stepper-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 3H21V9"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 14L21 3"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <a href="https://coindcx.com/profile" target="blank" rel="noreferrer">
              Open Dashboard
            </a>
          </button>
        </div>
      </li>

      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            From the profile menu, go to <span>API Dashboard</span>.
          </h2>
          <img
            src="/images/broker_setup_guide/coin_dcx/step-1.png"
            className="w-100"
            alt="CoinDCX API Dashboard"
          />
        </div>
      </li>

      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click <span>Create A New One</span> and give it a name, for example <span>Cryptobot</span>.
            <span className="text-danger">Do not bind any IP address</span>
          </h2>
          <img
            src="/images/broker_setup_guide/coin_dcx/step-2.png"
            className="w-100"
            alt="CoinDCX create API key"
          />
        </div>
      </li>

      <li className="stepper_item" data-stepper="7">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Complete the verification — check your email/mobile and enter your <span>OTP code</span> and press{' '}
            <span>Create</span>.
          </h2>
          <img
            src="/images/broker_setup_guide/coin_dcx/step-3.png"
            className="w-100"
            alt="CoinDCX OTP Verification"
          />
        </div>
      </li>

      <li className="stepper_item" data-stepper="8">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            After successful verification, your <span>API Key</span> and <span>Secret</span> will appear.
          </h2>
          <img
            src="/images/broker_setup_guide/coin_dcx/step-4.png"
            className="w-100"
            alt="CoinDCX API key display"
          />
          <img
            src="/images/broker_setup_guide/coin_dcx/step-5.png"
            className="w-100"
            alt="CoinDCX API Secret display"
          />
        </div>
      </li>

      <li className="stepper_item" data-stepper="9">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            <span className="text-danger">Important:</span> Copy and store your API Key and Secret safely. The
            Secret will not be shown again.
          </h2>
          <img
            src="/images/broker_setup_guide/coin_dcx/step-6.png"
            className="w-100"
            alt="CoinDCX API Secret display"
          />
          <img
            src="/images/broker_setup_guide/coin_dcx/step-7.png"
            className="w-100"
            alt="CoinDCX API Creation Success Dashboard"
          />
        </div>
      </li>

      <li className="stepper_item" data-stepper="10">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Go back to your broker login page, paste your API credentials, and click <span>Login</span>. You
            have now successfully connected CoinDCX!
          </h2>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="CoinDCX setup complete" />
        </div>
      </li>
    </div>
  </div>
);

export default CoinDcx;
